import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { auth, fireDB } from "../../firebase/FirebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import Loader from '../../components/Loader/Loader'
import './Login.css';


function Signup() {
  const context = useContext(MyContext);
  const { loading, setLoading } = context;

  // navigate 
  const navigate = useNavigate();

  // User Signup State 
  const [userSignup, setUserSignup] = useState({
    name: "",
    email: "",
    password: "",
    role: "user"
  });

  const userSignupFunction = async (e) => {
    e.preventDefault();
      // validate using regex 
      let emailRegex = /^[A-Za-z]+[\d]+[@]+[gmail]+[.]com$/.test(userSignup.email);
  
    if (userSignup.name === "" || userSignup.email === "" || userSignup.password === "") {
      toast.error("All Fields are required")

    } else if (userSignup.name.length < 3) {
      toast.error("Name required minimum 3 char")
    } else if (userSignup.email.length < 14 || !emailRegex ) {
      toast.error("enter valid email or use @gmail.com")
    }
    else if (userSignup.password.length < 6) {
      toast.error("Password required minimum 6 char")
    }

    setLoading(true);
    try {
      const users = await createUserWithEmailAndPassword(auth, userSignup.email, userSignup.password);

      // create user object
      const user = {
        name: userSignup.name,
        email: users.user.email,
        uid: users.user.uid,
        role: userSignup.role,
        time: Timestamp.now(),
        date: new Date().toLocaleString(
          "en-US",
          {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }
        )
      }

      // create user Refrence
      const userRefrence = collection(fireDB, "user")

      // Add User Detail
      addDoc(userRefrence, user);

      setUserSignup({
        name: "",
        email: "",
        password: ""
      })

      toast.success("Signup Successfully");

      setLoading(false);
      navigate('/login');

    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }

  return (
    <div>

      <div className="h-screen  flex items-center justify-center ">
        {loading && <Loader />}
        <div className="relative  bottom-16">
 
    <div id="form-container" className="bg-green-500 p-10  rounded-lg shadow-2xl w-full md:w-[350px] relative z-10 transform transition duration-500 ease-in-out">
      <h2 id="form-title" className="text-center text-3xl font-bold mb-10 ">Signup</h2>
      <form className="space-y-5 form">
      <input className="w-full input h-10 border border-gray-800 px-3 rounded-lg" placeholder="Name" id="" name="" type="text" value={userSignup.name} onChange={(e) => setUserSignup({ ...userSignup, name: e.target.value })} />

        <input className="w-full input h-10 border border-gray-800 px-3 rounded-lg" placeholder="Email" id="" name="" type="text"   value={userSignup.email}
                        onChange={(e) => {
                          setUserSignup({
                                ...userSignup,
                                email: e.target.value
                            })
                        }} />
        <input className="w-full input h-10 border border-gray-800 px-3 rounded-lg" placeholder="Password" id="" name="" type="password"  value={userSignup.password}
                        onChange={(e) => {
                          setUserSignup({
                                ...userSignup,
                                password: e.target.value
                            })
                        }} />
                        
                        <div className="flex justify-center">         
        <button className="w-44 h-10 mt-2 bg-[#24da67] text-white font-semibold py-2 px-4 font-poppins rounded-xl focus:outline-none focus:shadow-outline"    onClick={userSignupFunction}>Sign up</button>
        </div>
        <Link to={"/login"} className="flex justify-center text-black text-sm font-medium mt-2 pt-2" >Already have an account / login</Link>
      
      </form>

    </div>
  </div>

      </div>

    </div>
  )
}

export default Signup